export function isItemInventoryReordered(item) {
  return Boolean(item.inventoryId && item.isReorder);
}